import { createSelector } from 'reselect';

import { getTextEditing, getPaging, mountSelectorAt } from 'utils/selectors';

const mount = mountSelectorAt('mail');

const getMailThreadsIdsForPage = mount((localState, props) => {
  const { page } = props;

  const threadsIds = localState.mailThreads.byPage[page];

  if(!threadsIds) {
    return [];
  }

  return threadsIds;
});

const getMailThreadMessagesById = mount(localState => localState.mailThreadMessages.byId);

const getMailThreadsById = mount(localState => localState.mailThreads.byId);

export const getMailThreads = createSelector(
  [getMailThreadsIdsForPage, getMailThreadsById, getMailThreadMessagesById],
  (threadsIdsForPage, threadsById, threadMessagesById) => {
    return threadsIdsForPage.map(threadId => {
      const thread = threadsById[threadId];

      return {
        ...thread,
        latestMessage: threadMessagesById[thread.latestMessage]
      };
    });
  }
);

export const getMailThreadMessagesIds = mount((localState, props) => {
  const { threadId, page } = props;
  const pagesForThread = localState.mailThreadMessages.byThreadId[threadId];

  if(!pagesForThread) {
    return [];
  }

  const threadMessagesIds = pagesForThread.byPage[page];

  if(!threadMessagesIds) {
    return [];
  }

  return threadMessagesIds;
});

export const getMailThreadMessages = createSelector(
    [getMailThreadMessagesIds, getMailThreadMessagesById],
    (threadMessagesIds, threadMessagesById) => {
      return threadMessagesIds.map(threadMessageId => threadMessagesById[threadMessageId]);
    });

export const getMailTextEditing = mount((localState, key) => getTextEditing(localState.textEditing[key]));

export const getMailPaging = mount((localState, key, options) => getPaging(localState.paging[key], options));

export const getMailEmojis = mount((localState, key) => localState.emojis[key]);



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/selectors.js
 **/